export default {
    SUBMIT_CONTRACT_FORM: 'submitContractForm',
    SUBMIT_UPDATE_CONTRACT_FORM: 'submitUpdateContractForm',
    INCLUDE_IN_INCOME_EXPENSES: 'includeInIncomeExpenses',
    REVOKE_RECOGNITION_OF_INCOME_EXPENSES: 'revokeRecognitionOfIncomeExpenses',
}
